import React from "react";
import { Container, Row, Col, Button } from "reactstrap";

const SideBySide = ({
  headline,
  paragraph,
  orientation,
  buttonText,
  offset,
  showButton,
  imageUrl,
  alt,
  leftImgWidth,
  rightImgWidth,
  mobile,
  link
}) => {
  function renderButton() {
    if (showButton) {
      return (
        <a target="_blank" rel="noopener noreferrer" href={link}>
          <Button size="lg" className="sidebyside-button">
            {buttonText}
          </Button>
        </a>
      );
    }
  }

  if (mobile) {
    return (
      <Container fluid={true}>
        <Row>
          <Col xs="12" md="4" style={{ display: "flex", alignItems: "center", justifyContent: "center" }}>
            <img className="sidebyside-image" src={imageUrl} alt={alt} />
          </Col>
        </Row>
        <Row>
          <Col
            xs="12"
            md="5"
            style={{ textAlign: "left", display: "flex", justifyContent: "center", alignItems: "center" }}
          >
            <div style={{ display: "table", height: rightImgWidth }}>
              <div style={{ display: "table-cell", verticalAlign: "middle" }}>
                <h4 className="sidebyside-headline">{headline}</h4>
                <h3 className="sidebyside-paragraph">{paragraph}</h3>
                {renderButton()}
              </div>
            </div>
          </Col>
        </Row>
      </Container>
    );
  } else {
    return (
      <Container fluid={true}>
        {orientation === "left" ? (
          <Row>
            <Col xs="1" md="1"></Col>
            <Col
              xs="12"
              md="5"
              style={{ textAlign: "left", display: "flex", justifyContent: "center", alignItems: "center" }}
            >
              <div style={{ display: "table", height: rightImgWidth }}>
                <div style={{ display: "table-cell", verticalAlign: "middle" }}>
                  <h4 className="sidebyside-headline">{headline}</h4>
                  <h3 className="sidebyside-paragraph">{paragraph}</h3>
                  {renderButton()}
                </div>
              </div>
            </Col>
            <Col xs="1" md="1"></Col>
            <Col xs="12" md="4" style={{ display: "flex", alignItems: "center", justifyContent: "center" }}>
              <img className="sidebyside-image" src={imageUrl} alt={alt} />
            </Col>
            <Col xs="2" md="1"></Col>
          </Row>
        ) : (
          <Row>
            <Col xs="1" md="1"></Col>
            <Col xs="12" md="4" style={{ display: "flex", alignItems: "center", justifyContent: "center" }}>
              <img className="sidebyside-image" src={imageUrl} alt={alt} style={{ width: leftImgWidth }} />
            </Col>
            <Col xs="1" md="1"></Col>
            <Col
              xs="12"
              md="5"
              style={{ textAlign: "left", display: "flex", justifyContent: "center", alignItems: "center" }}
            >
              <div className="sidebyside-copy-container">
                <h4 className="sidebyside-headline">{headline}</h4>
                <h3 className="sidebyside-paragraph">{paragraph}</h3>
                {renderButton()}
              </div>
            </Col>
            <Col md="1"></Col>
          </Row>
        )}
      </Container>
    );
  }
};

export default SideBySide;
